import React from "react";
import "./about.css";
import ME from "../../Assets/pic2.png";
import { FaAward } from "react-icons/fa";
import { FaUserGraduate } from "react-icons/fa";

const About = () => {
  return (
    <section id="about">
      <h5 className="about__header">Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaUserGraduate className="about__icon" />
              <h5>Education</h5>
              <small>BSc. Degree in Computer Science</small>
            </article>
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>3+ Year Working </small>
            </article>
          </div>
          <p>
            I graduated from HilCoE School of Computer Science and Technology with a BSc.
            in Computer Science in February 2021. Additionally, I earned certifications in
            Computer Maintenance and Networking from Satcom in November 2022, and Digital Marketing, 
            Graphics Design, and Video Editing from Merahyan in August 2023.<br/>

            Professionally, I began my career as a Data Encoder at Benvino Trading P.L.C., where I worked 
            from February 2021 to March 2022. Later, I joined Merahyan Training Center as an ICT Teacher, 
            contributing from February 2023 to November 2023.<br/>

            Currently, I am a Full Stack Developer at Fergami Technologies, a role I began in November 2023 
            and continue to hold.
          </p>

          <a href="#contact" className="btn btn-primary">
            Contact Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
